export default __webpack_public_path__ + "static/media/bihada-factory-mission-09.f9360852.jpg";